import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const warehouseGuard: CanActivateFn = (route, state): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.userRole$.pipe(
    take(1), // Take the current value and complete
    map(role => {
      const isWarehouse = !!role && (role.toLowerCase() === 'warehouse' || role.toLowerCase() === 'shopeechecker' || role.toLowerCase() === 'admin');

      if (isWarehouse) {
        return true; // Allow access if user is warehouse, shopee_checker, or admin
      } else {
        // If user is logged in but not warehouse/shopee_checker role, redirect them
        console.warn('WarehouseGuard: User does not have warehouse or shopee checker access. Redirecting to dashboard.');
        router.navigate(['/dashboard']); // Redirect to the main dashboard page
        return false; // Prevent access to warehouse routes
      }
    })
  );
};